import { cx } from '@linaria/core';
import { makeUserFullName } from 'utils/users';
import { useAuthState } from 'modules/Auth/AuthContext';
import { useListWorkspaces } from 'modules/Auth/hooks';
import { useFeaturedFlags } from 'modules/FeaturedFlags/useFeaturedFlags';
import { hideAboveTab } from 'components/Navbar/Navbar.styles';
import { accountDefault } from './styles';
import { PopoverSection } from '../PopoverLayout';
import { Account, AccountProps } from '../Account';
import { CreateNewOrgButton } from './CreateNewOrgButton';

export interface AccountSelectorProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'className'> {
  onClose: () => void;
  withTag?: AccountProps['withTag'];
}

export const AccountSelector: React.FC<AccountSelectorProps> = ({ onClose, withTag }): JSX.Element => {
  const { authData } = useAuthState();
  const workspaces = useListWorkspaces();
  const [hasOrgAccess] = useFeaturedFlags(['OrgCreateOrganization']);

  const loggedInUserFullName = authData ? makeUserFullName(authData) : '';

  return (
    <>
      <PopoverSection title="Account">
        <Account
          as="anchor"
          type="user"
          href={`/${authData?.user_id}/settings`}
          name={authData?.user_id}
          subtitle={loggedInUserFullName}
          withTag={withTag}
          iconSize={40}
          className={cx(!workspaces.length && accountDefault)}
          onClick={onClose}
        />
      </PopoverSection>

      {/* Show for mobile devices only */}
      {hasOrgAccess && (
        <PopoverSection className={hideAboveTab}>
          <CreateNewOrgButton onClose={onClose} />
        </PopoverSection>
      )}
    </>
  );
};
